import {AppConfig} from "./AppConfig";
import store from "../../store/store-app";

export class StorageHelper {

    static get(clave) {
        return localStorage.getItem(clave);
    }

    static delete(clave) {
        localStorage.removeItem(clave);
        if (clave == AppConfig.TOKEN_CLAVE) store.dispatch('cambiaUsuarioLocalStorage');
    }

    static put(clave, valor) {
        localStorage.setItem(clave, valor);
        if (clave == AppConfig.TOKEN_CLAVE) store.dispatch('cambiaUsuarioLocalStorage');
    }
}